import { styled } from 'styled-components';
import { DateFilterLeftOverflow } from './QuickFilterItem';
import { Colors } from '../../../../play-core/styles/Colors';
export const StyledDateFilter = styled.div.withConfig({
  displayName: "DateFilterstyles__StyledDateFilter",
  componentId: "sc-1l7blzi-0"
})(["position:relative;flex:1 1 auto;"]);
export const QuickFilterSection = styled.ul.withConfig({
  displayName: "DateFilterstyles__QuickFilterSection",
  componentId: "sc-1l7blzi-1"
})(["padding-top:8px;margin-left:-", "px;width:100%;"], DateFilterLeftOverflow);
export const Divider = styled.div.withConfig({
  displayName: "DateFilterstyles__Divider",
  componentId: "sc-1l7blzi-2"
})(["position:relative;grid-column:1/4;grid-row:3;height:8px;border-bottom:1px solid ", ";"], Colors.GREY_2c2c2c);
export const DynamicRangeSection = styled.section.withConfig({
  displayName: "DateFilterstyles__DynamicRangeSection",
  componentId: "sc-1l7blzi-3"
})(["display:flex;flex-direction:column;justify-content:space-between;align-items:start;margin:16px 0;"]);
export const DateFilterContent = styled.div.withConfig({
  displayName: "DateFilterstyles__DateFilterContent",
  componentId: "sc-1l7blzi-4"
})(["display:grid;width:100%;margin-left:-", "px;padding-left:", "px;grid-column-gap:26px;grid-template-columns:280px 1fr;grid-template-rows:1fr 26px;> *:nth-child(3){grid-row:2;grid-column:1/3;}"], DateFilterLeftOverflow, DateFilterLeftOverflow);